import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ProductosTasas} from '../_models/productos-tasas';
import {ProductosSolicitudesLlaves} from '../_models/productos-solicitudes-llaves';

@Injectable({
  providedIn: 'root'
})
export class ProductosSolicitudesLlavesService {
  private rutaServicio = AppSettings.rutServiciosAPL + '/api/productosSolicitudesLlaves/';
  constructor(private httpClient: HttpClient, private autenticacionService: AutenticacionService) { }


  listadoHabilitadoxProducto(idProducto): Observable<ProductosSolicitudesLlaves[]> {
    return this.httpClient.get( this.rutaServicio + 'producto/' + idProducto ).pipe( map( res => res as ProductosSolicitudesLlaves[] ) );
  }


  bulk( regActualizar: ProductosSolicitudesLlaves[] ): Observable<ProductosSolicitudesLlaves[]> {
    regActualizar.map( ( s: ProductosSolicitudesLlaves ) => {
      s.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutaServicio + 'bulk', regActualizar ).pipe( map( res => res as ProductosSolicitudesLlaves[] ) );
  }
}
